import {DB} from '@/store/kysely_types';
import {Kysely} from 'kysely';

type Props = {
    db: Kysely<DB>;
}

export default async function (props: Props) {
    await runMigration(props);
}

const runMigration = async (props: Props) => {
    const db = props.db;
    
    // Get all chord_lyrics attributes that are still in the old string format
    const chordLyricsAttributes = await db
        .selectFrom('Attribute')
        .selectAll()
        .where('name', '=', 'chord_lyrics')
        .execute();
    
    console.log(`Found ${chordLyricsAttributes.length} chord_lyrics attributes to migrate`);
    
    for (const attribute of chordLyricsAttributes) {
        try {
            // Check if it's already JSON by trying to parse it
            let isAlreadyJson = false;
            try {
                const parsed = JSON.parse(attribute.value || '');
                // If it parses and has a lyrics property, it's already migrated
                if (typeof parsed === 'object' && parsed !== null && 'lyrics' in parsed) {
                    isAlreadyJson = true;
                }
            } catch {
                // Not JSON, needs migration
            }
            
            if (isAlreadyJson) {
                console.log(`Attribute ${attribute.id} is already migrated, skipping`);
                continue;
            }
            
            // Create the new JSON structure
            const newValue = JSON.stringify({
                lyrics: attribute.value || '',
                transposeSettings: {
                    transposeNumber: 0
                }
            });
            
            // Update the attribute
            await db
                .updateTable('Attribute')
                .set({ value: newValue })
                .where('id', '=', attribute.id)
                .execute();
            
            console.log(`Migrated chord_lyrics attribute ${attribute.id}`);
        } catch (error) {
            console.error(`Failed to migrate chord_lyrics attribute ${attribute.id}:`, error);
            // Continue with other attributes even if one fails
        }
    }
    
    console.log('Chord lyrics migration completed');
};